<form *ngIf="consentDetail" [formGroup]="questionForm">

  <h4 class="mt-5 text-left">
    {{ consentDetail.question }}
  </h4>
  <div *ngIf="consentDetail.type === 'choices'">
    <mat-radio-group class="mt-3" formControlName="answer">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12" *ngFor="let c of consentDetail.choices">
          <mat-radio-button [value]="c.choices_id" class="mt-3">
            {{ c.choices_detail }}
          </mat-radio-button>
        </div>
      </div>
    </mat-radio-group>
  </div>

  <div *ngIf="consentDetail.type === 'text'">
    <input type="text" class="form-control" formControlName="answer" style="width: 100%;">
  </div>

  <div *ngIf="consentDetail.type === 'checkbox'">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12" *ngFor="let c of consentDetail.choices">
        <mat-checkbox [value]="c.choices_id" (change)="patchVal($event)">{{ c.choices_detail }}</mat-checkbox>
      </div>
    </div>
  </div>

</form>
